import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const EquipmentFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'Cardio', label: 'Cardio' },
    { value: 'Strength', label: 'Strength' },
    { value: 'Free Weights', label: 'Free Weights' },
    { value: 'Functional', label: 'Functional' },
    { value: 'Accessories', label: 'Accessories' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'operational', label: 'Operational' },
    { value: 'maintenance', label: 'In Maintenance' },
    { value: 'out-of-service', label: 'Out of Service' },
    { value: 'retired', label: 'Retired' }
  ];

  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'Main Floor', label: 'Main Floor' },
    { value: 'Weight Room', label: 'Weight Room' },
    { value: 'Cardio Zone', label: 'Cardio Zone' },
    { value: 'Studio', label: 'Studio' },
    { value: 'Storage', label: 'Storage' }
  ];

  const conditionOptions = [
    { value: 'all', label: 'All Conditions' },
    { value: 'excellent', label: 'Excellent' },
    { value: 'good', label: 'Good' },
    { value: 'fair', label: 'Fair' },
    { value: 'poor', label: 'Poor' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} />
          Equipment Filters
        </h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
        >
          Clear All
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <Input
          type="search"
          placeholder="Search equipment, serial number..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full lg:col-span-2"
        />

        <Select
          placeholder="Category"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => onFilterChange('category', value)}
        />

        <Select
          placeholder="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          placeholder="Location"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
        />

        <Select
          placeholder="Condition"
          options={conditionOptions}
          value={filters?.condition}
          onChange={(value) => onFilterChange('condition', value)}
        />
      </div>
    </div>
  );
};

export default EquipmentFilters;